import {useState, useEffect} from 'react'

import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import team2 from "assets/images/team-2.jpg";

function getFromLocalStorage(imageId){
    let data =  localStorage.getItem(imageId);
    return 'data:image/png;base64,' + data;
  }

/* eslint-disable react/prop-types */
export default function ModalOfferData({offer}) {
    return (
        <>
        {offer && 
            <Grid container spacing={1}>
                <Grid item xs={12} >
                    <MDBox display="flex" alignItems="center" lineHeight={1} pt={1} pl={1}>
                        <MDAvatar src={getFromLocalStorage(offer['avatar']['photo_id'])} name={offer['avatar']['nickname']} size="lg" />
                        <MDBox ml={2} lineHeight={1}>
                            <MDTypography display="block" variant="button" fontWeight="medium">
                            {offer['avatar']['nickname']}
                            </MDTypography>
                            <MDTypography variant="caption">{"Level "+ offer['avatar']['level']}</MDTypography>
                        </MDBox>
                    </MDBox>
                    <Grid item xs={12} display={"flex"} alignItems={"flex-start"} pb={1} pt={3}>
                        <MDTypography
                            display="flex"
                            variant="caption"
                            fontWeight="bold"
                            textTransform="uppercase"
                            mt={1}
                            mb={1}
                            ml={1}
                        >
                            {offer['product']["product_name"]}
                        </MDTypography>
                    </Grid>
                    <MDBox display="flex" lineHeight={1} pb={1}>
                        <MDBox
                            component="img"
                            sx={{
                                height: 200,
                                width: 160,
                            }}
                            borderRadius={20}
                            alt="Product"
                            src={getFromLocalStorage(offer['product']['product_photos_ids'][0])}
                        />
                        <MDBox display="flex" justifyContent="space-between" lineHeight={1} flexDirection={"column"}>
                            <MDBox >
                                <MDTypography
                                    display="flex"
                                    variant="caption"
                                    fontWeight="regular"
                                    mt={1}
                                    mb={1}
                                    ml={1}
                                >
                                    {"Item is currently priced at: "}
                                </MDTypography>
                                <MDTypography
                                    display="flex"
                                    variant="h7"
                                    fontWeight="bold"
                                    mb={1}
                                    ml={1}
                                >
                                    {(offer['product']["product_price"]/100).toFixed(2) + " $"}
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography
                                    display="flex"
                                    variant="caption"
                                    fontWeight="regular"
                                    ml={1}
                                >
                                    {offer['product']["product_code"]}
                                </MDTypography>
                                {Object.keys(offer['product']['product_properties']).map((property_key) => (
                                    <MDBox lineHeight={1} key={property_key} >
                                        <MDTypography
                                            display="flex"
                                            variant="caption"
                                            fontWeight="regular"
                                            ml={1}
                                        >
                                            {property_key+": "+offer['product']['product_properties'][property_key]}
                                        </MDTypography>
                                    </MDBox>
                                ))}                               
                            </MDBox>
                            <MDBox>
                                <MDTypography
                                    display="flex"
                                    variant="caption"
                                    fontWeight="regular"
                                    mt={1}
                                    mb={1}
                                    ml={1}
                                >
                                    {"Customer will pay:"}
                                </MDTypography>
                                <MDTypography
                                    display="flex"
                                    variant="h7"
                                    fontWeight="bold"
                                    color="success"
                                    mb={1}
                                    ml={1}
                                >
                                    {(offer['offer']["final_price"]/100).toFixed(2) + " $"}
                                </MDTypography>
                            </MDBox>
                        </MDBox>
                    </MDBox>
                    <MDBox display="flex" alignItems="center" lineHeight={1} pt={3} pl={1} justifyContent="center">
                        <MDTypography display="block" variant="button" fontWeight="medium">
                        {"Discount code: "+offer['offer']['barcode']}
                        </MDTypography>
                    </MDBox>
                </Grid>
            </Grid>
            }
        </>


    );
}